module.exports = __webpack_public_path__ + "img/twitter.7768bfc3.svg";